import { memo, PropsWithChildren } from "react";
import { cn } from "@/lib/utils.ts";

export const TableRowRenderer = memo(function TableRowRenderer({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) {
  return <div className={cn("px-1", className)}>{children}</div>;
});
